import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminIcon = () => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="7" r="3.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M3.5 17C3.5 13.5 6.5 11 10 11C13.5 11 16.5 13.5 16.5 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export default function Layout({ children }) {
  const { user, logout } = useAuth();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)', display: 'flex', flexDirection: 'column' }}>
      <header style={{
        background: 'var(--color-dark-blue)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        padding: '0 1.5rem',
        height: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
          <NavLink to="/" style={{ textDecoration: 'none' }}>
            <span style={{ fontSize: '1.25rem', fontWeight: 700, color: '#fff', letterSpacing: '-0.02em' }}>
              <span style={{ color: 'var(--color-green)' }}>e</span>mew
            </span>
            <span style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)', marginLeft: '0.5rem', fontWeight: 500 }}>
              AIVA
            </span>
          </NavLink>

          <NavLink
            to="/"
            end
            style={({ isActive }) => ({
              fontSize: '0.875rem',
              fontWeight: 500,
              color: isActive ? '#fff' : 'rgba(255,255,255,0.6)',
              textDecoration: 'none',
              padding: '0.25rem 0',
              borderBottom: isActive ? '2px solid var(--color-green)' : '2px solid transparent',
            })}
          >
            Assessments
          </NavLink>

          {user?.isAdmin && (
            <NavLink
              to="/admin"
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: '0.375rem',
                fontSize: '0.875rem',
                fontWeight: 500,
                color: isActive ? '#fff' : 'rgba(255,255,255,0.6)',
                textDecoration: 'none',
                padding: '0.25rem 0',
                borderBottom: isActive ? '2px solid var(--color-green)' : '2px solid transparent',
              })}
            >
              <AdminIcon />
              Admin
            </NavLink>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          {user?.picture ? (
            <img src={user.picture} alt="" style={{ width: 30, height: 30, borderRadius: '50%' }} referrerPolicy="no-referrer" />
          ) : (
            <div style={{
              width: 30, height: 30, borderRadius: '50%',
              background: 'var(--color-blue)', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '0.8rem', fontWeight: 600,
            }}>
              {user?.name?.[0] || user?.email?.[0] || '?'}
            </div>
          )}
          <span style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.8)', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user?.name || user?.email}
          </span>
          <button
            onClick={logout}
            style={{
              background: 'none', border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: 'var(--radius-sm)', cursor: 'pointer',
              fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)',
              padding: '0.25rem 0.5rem',
            }}
          >
            Sign out
          </button>
        </div>
      </header>

      <main style={{ flex: 1, padding: '1.5rem', maxWidth: 1200, width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>
        {children}
      </main>
    </div>
  );
}
